import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { Role, UserAdmin } from '../../../shared/models/user.model';

interface UsersActionsCellRendererParams extends ICellRendererParams {
  canAdjustBalance: boolean;
  onAction: (clickedItem: string, row: UserAdmin) => void;
}

@Component({
  standalone: false,
  selector: 'app-users-actions',
  templateUrl: './users-actions.component.html',
  styleUrls: ['./users-actions.component.scss'],
})
export class UsersActionsComponent {
  currentRow: UserAdmin;
  canAdjustBalanceValue = false;
  private actionHandler?: (clickedItem: string, row: UserAdmin) => void;

  agInit(params: UsersActionsCellRendererParams): void {
    this.currentRow = params.data;
    this.canAdjustBalanceValue = params.canAdjustBalance;
    this.actionHandler = params.onAction;
  }

  refresh(params: UsersActionsCellRendererParams) {
    this.currentRow = params.data;
    this.canAdjustBalanceValue = params.canAdjustBalance;
    this.actionHandler = params.onAction;
    return true;
  }

  onClick(clickedItem: string) {
    this.actionHandler?.(clickedItem, this.currentRow);
  }

  formatNumericBoolean(n): string {
    if (typeof n === 'boolean') {
      return n ? 'yes' : 'no';
    }
    return n === '1' ? 'yes' : 'no';
  }

  isResendVerificationPossible(): boolean {
    return this.formatNumericBoolean(this.currentRow.emailVerified) === 'no' && this.currentRow.role === Role.MAIN;
  }

  canAdjustBalance(): boolean {
    return this.canAdjustBalanceValue;
  }
}
